export default __webpack_public_path__ + "static/matrix-model-838067e893c9db80d2ca9dc7a7509b3a.png";